import { USER_LIST, UPDATE_PENDING_USER_LIST, PENDING_USER_LIST, USER_LIST_FILTER_UPDATE, USER_LIST_PAGE_UPDATE, ROLE_LIST, REGION_LIST, GET_USER_DETAILS, SAVE_USER_DETAILS, REJECTED_USER_LIST, UNMOUNT_EDIT_USER, SHARE_LINK_BY_EMAIL } from '../constants/constants';



export const userList = () => {
    return {
        type: USER_LIST
    }
}

export const pendingUserList = () => {
    return {
        type: PENDING_USER_LIST
    }
}

export const rejectedUserList = () => {
    return {
        type: REJECTED_USER_LIST
    }
}

export const updatePendingList = (data: any) => {
    return {
        type: UPDATE_PENDING_USER_LIST,
        payload: data
    }
}

export const updateUserListFilter = (data: any) => {
    return {
        type: USER_LIST_FILTER_UPDATE,
        payload: data
    }
}

export const updateUserListPage = (data: any) => {
    return {
        type: USER_LIST_PAGE_UPDATE,
        payload: data
    }
}

export const getRoles = () => {
    return {
        type: ROLE_LIST
    }

}

export const getRegions = () => {
    return {
        type: REGION_LIST
    }

}

export const getUserDetails = (data: any) => {
    return {
        type: GET_USER_DETAILS,
        payload: data
    }
}

export const saveUserDetails = (data: any) => {
    return {
        type: SAVE_USER_DETAILS,
        payload: data
    }
}

export const unmountEditUser = (data: any) => {
    return {
        type: UNMOUNT_EDIT_USER,
        payload: data
    }
}

export const shareLinkByEmail = (data: any) => {
    return {
        type: SHARE_LINK_BY_EMAIL,
        payload: data
    }
}




// WEBPACK FOOTER //
// ./src/actions/action.user.tsx